import { Box, LinearProgress, Tooltip, Typography } from "@mui/material";
import type { LinearProgressProps } from "@mui/material";
import { BasicFormatter } from "../../utils/basicFormatter";

interface LinearProgressWithLabelProps extends Omit<
  LinearProgressProps,
  "value"
> {
  value?: number;
  maxValue?: number;
  title: string;
}

const LinearProgressWithLabel = ({
  value = 0,
  maxValue = 0,
  title,
  ...rest
}: LinearProgressWithLabelProps) => {
  const percentageValue = maxValue > 0 ? (value / maxValue) * 100 : 0;

  return (
    <>
      <Typography>{title}</Typography>
      <Tooltip
        title={`${title}: ${BasicFormatter.numberFormat(
          value
        )} / ${BasicFormatter.numberFormat(maxValue)}`}
        followCursor
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{ width: "100%", mr: 1, display: "flex", alignItems: "center" }}
          >
            <LinearProgress
              variant="determinate"
              value={percentageValue}
              {...rest}
              sx={{ width: "100%" }}
            />
          </Box>
          <Box sx={{ minWidth: 35 }}>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary" }}
            >{`${Math.round(percentageValue)}%`}</Typography>
          </Box>
        </Box>
      </Tooltip>
    </>
  );
};

export { LinearProgressWithLabel };
